
import service1 from "../../images/services/cartracking3.png";
import service2 from "../../images/services/geofence.png";
import service3 from "../../images/services/fleetmanagement.png";
import service4 from "../../images/services/enginecutoff.png";
import service5 from "../../images/services/soundrecording.png";
import service6 from "../../images/services/stranger.png";
import service7 from "../../images/services/panicbutton.png";
import service8 from "../../images/services/driveridentification.png";
import service9 from "../../images/services/locationhistory.png";

export const list = [
    {
        id: 1,
        cover: service1,
        name: "Real Time Car Tracking",
        description: "Get real time location of your car or vehicle",
    },
    {
        id: 2,
        cover: service2,
        name: "Vehicle Geofencing",
        description: "Set and implement geographical boundaries for your car"

    },
    {
        id: 3,
        cover: service3,
        name: "Vehicle Fleet Management",
        description: "Manage the fuel consuption of your car",
    },
    {
        id: 4,
        cover: service4,
        name: "Remote Engine Cutoff",
        description: "Dissable the engine power remotely whenever need be"

    }, {
        id: 5,
        cover: service5,
        name: "Remote Sound Recording",
        description: "Listen to conversations in your car",
    },
    {
        id: 6,
        cover: service6,
        name: "Get Passanger Alerts",
        description: "Get nottified when someone enters your car"

    }, {
        id: 7,
        cover: service7,
        name: "SoS Panic Button",
        description: "Press a secret panic button when in danger",
    },
    {
        id: 8,
        cover: service8,
        name: "AI Driver Recognition",
        description: "Get alerts when someone else is driving your vehicle"

    }, {
        id: 9,
        cover: service9,
        name: "Location History Report",
        description: "Get history reports and vehicle route playback",
    },
    {
        id: 10,
        cover: service1,
        name: "Real Time Car Tracking",
        description: "Get real time location of your car or vehicle",

    },
    {
        id: 11,
        cover: service2,
        name: "Vehicle Geofencing",
        description: "Set and implement geographical boundaries for your car"

    },
    {
        id: 12,
        cover: service3,
        name: "Vehicle Fleet Management",
        description: "Manage the fuel consuption of your car",
    },
    {
        id: 13,
        cover: service4,
        name: "Remote Engine Cutoff",
        description: "Dissable the engine power remotely whenever need be"

    },


];